export interface INavigationRoute {
  name: string;
  displayName: string;
  meta: { icon: string };
  children?: INavigationRoute[];
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    // {
    //   name: 'listAllContractors',
    //   displayName: 'menu.view-all-contractors',
    //   meta: {
    //     icon: 'group',
    //   },
    // },

    {
      name: 'contractSchedule',
      displayName: 'menu.view-all-contractor-schedules',
      meta: {
        icon: 'mso-event_note',
      },
    },
    {
      name: 'contractorWorker',
      displayName: 'menu.view-contractor-workers',
      meta: {
        icon: 'mso-groups_2',
      },
    },
    {
      name: 'contractorWorkerApproval',
      displayName: 'menu.view-contractor-worker-approval',
      meta: {
        icon: 'mso-how_to_reg',
      },
    },
    // {
    //   name: 'contractorReports',
    //   displayName: 'Reports',
    //   meta: {
    //     icon: 'mso-problem',
    //   },
    // },

    {
      name: 'contractorAccount',
      displayName: 'menu.view-contractor-account',
      meta: {
        icon: 'mso-account_circle',
      },
    },

    {
      name: 'townCouncilOverview',
      displayName: 'menu.view-tc-overview',
      meta: {
        icon: 'mso-dashboard_2',
      },
    },
    {
      name: 'townCouncilContractSchedule',
      displayName: 'menu.view-tc-contract-schedule',
      meta: {
        icon: 'mso-event_note',
      },
    },
    {
      name: 'townCouncilAdHocAccess',
      displayName: 'menu.view-tc-adhoc-access',
      meta: {
        icon: 'mso-calendar_view_month',
      },
    },
    {
      name: 'townCouncilDoors',
      displayName: 'menu.view-tc-doors',
      meta: {
        icon: 'mso-switch_access_2',
      },
    },
    {
      name: 'townCouncilContractorsList',
      displayName: 'menu.view-tc-contractors',
      meta: {
        icon: 'mso-assignment_ind',
      },
    },
    {
      name: 'townCouncilWorkerApproval',
      displayName: 'menu.view-tc-worker-approval',
      meta: {
        icon: 'mso-how_to_reg',
      },
    },
    {
      name: 'townCouncilAdhocApproval',
      displayName: 'menu.view-tc-adhoc-approval',
      meta: {
        icon: 'mso-person_check',
      },
    },
    {
      name: 'townCouncilAudit',
      displayName: 'Audit',
      meta: {
        icon: 'mso-problem',
      },
    },
    // {
    //   name: 'townCouncilAccess',
    //   displayName: 'Access',
    //   meta: {
    //     icon: 'mso-meeting_room',
    //   },
    // },
    {
      name: 'townCouncilAccount',
      displayName: 'menu.view-tc-account',
      meta: {
        icon: 'mso-account_circle',
      },
    },
    {
      name: 'logout',
      displayName: 'menu.logout',
      meta: {
        icon: 'mso-logout',
      },
    },
  ] as INavigationRoute[],
};
